module.exports = __webpack_public_path__ + "static/media/stop-10.1b4994cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-10.svg
// module id = 1377
// module chunks = 0